import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import mediaFullSchema from '@utils/validate/blocksSchemes//mediaFullSchema';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const catalogSectionBlockSchema = Joi.object({
  type: Joi.string().valid('catalogSectionBlock').required(),
  code: Joi.string().allow('', null).required(),
  header: Joi.string().allow('', null).required(),
  rows: Joi.array().items(Joi.object({
    items: Joi.array().items(Joi.object({
      header: Joi.string().allow('', null),
      variant: Joi.string().allow('', null),
      animation: Joi.string().allow('', null),
      description: Joi.string().allow('', null),
      textColor: Joi.string().allow('', null),
      textHoverColor: Joi.string().allow('', null),
      bgColor: Joi.string().allow('', null),
      bgHoverColor: Joi.string().allow('', null),
      filePath: Joi.string().allow('', null),
      fileTarget: Joi.string().allow('', null),
      buttonText: Joi.string().allow('', null),
      buttonVariant: Joi.string().allow('', null),
      image: mediaUrlSchema.allow('', null),
      hoverImage: mediaUrlSchema.allow('', null),
      video: mediaFullSchema(true) || mediaUrlSchema.allow('', null)
    }).unknown(true)),
    layout: Joi.string()
  })).required(),
  blockAppearance: Joi.object(blockAppearanceSchema)
}).unknown(true);
export default catalogSectionBlockSchema;